/**
 * src/services/shareApi.js — live-share host client (T12).
 *
 * HOST (the signed-in presenter) talks to the share backend (server/routes/
 * share.js). Broadcast = live mirror, NOT a data grant: the host pushes
 * screen-state frames; viewers get zero data access.
 *
 * Terminology: HOST / Viewer-Guest — 'Lead' stays reserved for the bot concept.
 */

// Response shapes follow the server's {error:{code,message}} contract.
async function handle(response) {
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const err = new Error(body?.error?.message || 'Share request failed');
    err.code = body?.error?.code;
    throw err;
  }
  return body;
}

export async function createShare({ businessId, screenSlug, durationHours }) {
  const token = (await import('./pb.js')).pb.authStore.token;
  const response = await fetch('/api/share', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ businessId, screenSlug, durationHours })
  });
  return handle(response);
}

export async function listShares(businessId) {
  const token = (await import('./pb.js')).pb.authStore.token;
  const response = await fetch(`/api/share?businessId=${encodeURIComponent(businessId)}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return handle(response);
}

export async function revokeShare(shareId) {
  const token = (await import('./pb.js')).pb.authStore.token;
  const response = await fetch(`/api/share/${encodeURIComponent(shareId)}/revoke`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` }
  });
  return handle(response);
}

export async function pushFrame(shareId, { screenSlug, payload }) {
  const token = (await import('./pb.js')).pb.authStore.token;
  const response = await fetch(`/api/share/${encodeURIComponent(shareId)}/frame`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ screenSlug, payload })
  });
  return handle(response);
}
